import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from '../pages/login/LoginPage';
import AdminUserManagementPage from '../pages/userManagement/AdminUserManagementPage';
import ReviewerUserManagementPage from '../pages/userManagement/RegUserManagementPage';
import VideoPlayerPage from '../pages/videoPlayer/VideoPlayerPage';
import MainPage from '../pages/main/MainPage';
import ChartsPage from '../pages/charts/ChartsPage';
import ToolsPage from '../pages/tools/ToolsPage';
import { extendSession } from '../apis/sessionTokenAPI';
import SessionExpiredDialog from '../components/SessionExpiredDialog';
import AppToast from '../components/AppToast';

// Check authentication by trying to extend session (validates cookie)
const isAuthenticated = async () => {
  try {
    await extendSession();
    console.log("Session validated successfully");
    return true;
  } catch (error) {
    console.log("Session validation failed:", error);
    return false;
  }
};

// Only the login page is not protected, all other pages are protected
const ProtectedRoute = ({ children }) => {
  const [isAuth, setIsAuth] = React.useState(null); // null = checking, true/false = result

  React.useEffect(() => {
    let isMounted = true; // Track if the component is mounted.

    const checkAuth = async () => {
      const authResult = await isAuthenticated();
      // Only update authentication state when this component is still mounted to avoid racing condition
      if (isMounted) {
        setIsAuth(authResult);
      }
    };
    checkAuth();

    return () => {
      isMounted = false;
    }
  }, []);

  // Show loading while checking authentication
  if (isAuth === null) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRouter = () => (
  <Router>
    <SessionExpiredDialog />
    <AppToast />
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/main" element={<ProtectedRoute><MainPage /></ProtectedRoute>} />
      <Route path="/charts" element={<ProtectedRoute><ChartsPage /></ProtectedRoute>} />
      <Route path="/tools" element={<ProtectedRoute><ToolsPage /></ProtectedRoute>} />
      <Route path="/admin-user-management" element={<ProtectedRoute><AdminUserManagementPage /></ProtectedRoute>} />
      <Route path="/reviewer-user-management" element={<ProtectedRoute><ReviewerUserManagementPage /></ProtectedRoute>} />
      <Route path="/reg-user-management" element={<Navigate to="/reviewer-user-management" replace />} />
      <Route path="/video-player" element={<ProtectedRoute><VideoPlayerPage /></ProtectedRoute>} />
    </Routes>
  </Router>
);

export default AppRouter;
